/*eslint-disable  react/jsx-indent*/
import React, {Fragment, useEffect, useMemo, useState} from 'react';
import {connect, useDispatch} from 'react-redux';
import {useLocation, useNavigate, useParams} from 'react-router-dom';
import moment from 'moment';
import Select from 'react-select';
import {
  biodataIc,
  // chevronRight,
  // verificationsIc,
  addressIc,
  ipDeviceCheckIc,
  chevronRightSm,
  amlCheckIc,
  failed_t,
} from '../../assets/images/images';
import {
  DashboardLayout,
  SecondaryButton,
  PrimaryButton,
  DropdownIndicator,
  customStyles,
  SkeletonLoader,
} from '../../components';
import {Constants, capitalizeEveryWord} from '../../helpers';
import ActivityLog from './ActivityLog';
import ReusableLink from './ReusableLink';
import ReviewUserModal from './ReviewUserModal';
import SessionsModal from './SessionsModal';
import * as Actions from '../../store/actions';

import {getCookieValue} from '../../helpers/getCookie';
import {getStatusTextAndStyles} from '../../helpers/getStatusTextAndStyles';
import ReverificationModal from './ReverificationModal';
import ReverificationSuccessModal from './ReverificationSucessModal';
import {shortenLargeNumbers} from '../../helpers/shortenLargeNumbers';
import {useQuery} from 'react-query';
import {
  fetchVerifications,
  resendWebhook,
} from '../../requests/queries/verifications';
import Breadcrumbs from 'components/BreadCrumbs';
import {toast} from 'react-toastify';
import {convertSVGToBase64} from 'helpers/convertSVGToBase64';
import {pdf} from '@react-pdf/renderer';
import {VerificationReportDocument} from './verificationReportDocument';

function CostSummary({summary = [], displayPrice}) {
  const [seeMore, setSeeMore] = useState(false);
  const ARR = seeMore ? summary : summary.slice(0, 4);
  return (
    <div className="mt-2 flex flex-col gap-2">
      {ARR.map((item, index) => (
        <Fragment key={index}>
          {!['index', 'countries'].includes(item?.name) && (
            <div
              key={index}
              className="flex items-center justify-between gap-2"
            >
              <p className="text-sm text-body w-full capitalize">{item.name}</p>
              <p className="text-sm text-brandBlue">
                {displayPrice(item.cost, item.cost / 100)}
              </p>
            </div>
          )}
        </Fragment>
      ))}

      {summary?.length > 4 && (
        <SecondaryButton
          buttonText={seeMore ? 'See less' : 'See more'}
          fontSize="text-xs"
          className="w-fit"
          xPadding="px-2"
          yPadding="py-2"
          btnHeight="h-fit"
          onClick={() => setSeeMore(!seeMore)}
        />
      )}
    </div>
  );
}

function Layout({
  verifications: {session_summary, loading},
  children,
  verificationId,
  auth: {userDetails, user},
}) {
  const {slug} = useParams();
  const [openReview, setOpenReview] = useState(false);
  const [openSessions, setOpenSessions] = useState(false);
  const [openRetryVerification, setOpenRetryVerification] = useState(false);
  const [base64URL, setBase64URL] = useState('');
  const [retryType, setRetryType] = useState('retry');
  const [selectedVerification, setSelectedVerification] = useState(null);
  const [openRetryVerificationSuccess, setOpenRetryVerificationSuccess] =
    useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const location = window.location.pathname;
  const route = location.split('/')[2];
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {state} = useLocation();

  const VERIFICATION = session_summary?.data?.Verification;
  const COST = session_summary?.data?.cost || [];
  const vStatus = VERIFICATION?.status?.toLowerCase();
  const reviewProcess = VERIFICATION?.review_process;
  const reviewStatus = VERIFICATION?.review_status;
  const webhookStatus = session_summary?.data?.webhook_status;

  useEffect(() => {
    convertSVGToBase64().then(logo => setBase64URL(logo));
  }, []);

  const pdfData = useMemo(() => {
    const verification = session_summary?.data?.Verification;
    const device = session_summary?.data?.device;
    const ip = session_summary?.data?.ip;
    const data = verification?.data || {};

    return {
      headerInfo: {
        name:
          data?.first_name && data?.last_name
            ? `${data.first_name} ${data.last_name}`
            : 'Abiodun Oladipo',
        refId: verification?.reference_id || 'DJ-18CCE7022',
        status: verification?.status?.toUpperCase() || 'Completed',
        timestamp: verification?.date_created
          ? moment(verification.date_created)
              .format('DD MMM YYYY, hh:mm A')
              .toUpperCase()
          : '25TH JUNE 2024, 02:24 AM',
      },
      governmentData: {
        AVATAR:
          data?.first_name && data?.last_name
            ? `${data.first_name[0]}${data.last_name[0]}`.toUpperCase()
            : 'DA',
        FIRST_NAME: data?.first_name || 'Abiodun',
        MIDDLE_NAME: data?.middle_name || 'Dauda',
        SURNAME: data?.last_name || 'Oladapo',
        BVN_NO: data?.bvn || '111123344422',
        GENDER: data?.gender || 'Female',
        BIRTH_DATE: data?.dob || '1988-05-17',
        PHONE_NUMBER_1: data?.phone || '091920930030',
      },
      deviceInfo: {
        OS: device?.os || 'OS X',
        MODEL: device?.model || 'x64',
        BROWSER: device?.browser || 'Chrome',
        BROWSER_VERSION: device?.browser_version || '126.0.0.0',
        PLATFORM: device?.platform || 'Web',
      },
      ipInfo: {
        IP_ADDRESS: ip?.ip || '41.76.192.41',
        COUNTRY: ip?.country || 'Nigeria',
        REGION_NAME: ip?.region || 'Lagos',
        CITY: ip?.city || 'Lagos',
        LAT: ip?.latitude?.toString() || '6.4474',
        LON: ip?.longitude?.toString() || '3.3903',
        MOBILE_NETWORK: ip?.is_mobile?.toString() || 'False',
        VPN_PROXY: ip?.is_proxy?.toString() || 'False',
        ISP: ip?.isp || 'Broad Based Communications Limited',
        SERVER_HOSTING: ip?.is_hosting?.toString() || 'True',
      },
      timeSpent: {
        TIME_SPENT: verification?.completion_time || '58:54',
      },
    };
  }, [session_summary]);

  const handleDownload = async () => {
    setIsDownloading(true);
    try {
      const blob = await pdf(
        <VerificationReportDocument
          data={pdfData}
          userName={user && `${user?.first_name} ${user?.last_name}`}
          logoImage={base64URL}
        />,
      ).toBlob();

      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `verification-report-${pdfData.headerInfo.refId}.pdf`;
      document.body.appendChild(a);
      a.click();

      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error generating PDF:', error);
      toast.error('Could not generate PDF report.');
    }
    setIsDownloading(false);
  };

  // const isReviewerStatus = ![null, undefined, 0].includes(reviewStatus);
  // const REVIEW_STATUS = isReviewerStatus && reviewStatus;
  // const rStatus = getStatusWithNumbers(REVIEW_STATUS);

  const envData = getCookieValue('env');
  const params = useMemo(
    () => ({
      environment: envData?.toLowerCase(),
      reference_id: VERIFICATION?.reference_id,
      app_id: VERIFICATION?.app_id,
    }),
    [VERIFICATION?.app_id, VERIFICATION?.reference_id, envData],
  );

  const {data, isLoading, isFetching} = useQuery(
    ['retry-verifications', params],
    () => fetchVerifications(params),
    {
      onSuccess: data => {
        if (!isLoading && !isFetching && data?.data && data?.data?.length > 1) {
          localStorage.setItem('verificationList', JSON.stringify(data?.data));
        }
      },
      enabled: !!VERIFICATION?.reference_id,
    },
  );
  const {isLoading: isResending, refetch} = useQuery(
    ['resend-webhook', slug],
    () => resendWebhook(slug),
    {
      onSuccess: data => {
        toast.success(data?.message || 'Webhook resent successfully');
        dispatch(Actions.getSessionSummary(slug || state?.sessionId));
      },
      onError: error => {
        toast.error(error?.response?.data?.error || 'Error resending webhook');
      },
      enabled: false,
    },
  );

  const currentLists = JSON.parse(
    localStorage.getItem('verificationList'),
    '{}',
  );

  const verificationList = useMemo(
    () =>
      !isLoading &&
      data &&
      [...(data?.data || [])]?.map((version, index) => ({
        label:
          index === 0 ? (
            `Current Verification`
          ) : (
            <p className="font-bold text-sm">
              v{index}
              {' - '}
              <span className="font-thin text-sm">{`${moment(
                version?.datetime,
              ).format('MMM DD, h:mm a')}`}</span>
            </p>
          ),
        value: version?.verification_id,
      })),
    [data, isLoading],
  );

  const COST_SUMMARY =
    envData === 'Production'
      ? COST
      : // ? COST.filter(cost => Boolean(Number(cost.cost)))
        COST.map(cost => ({
          ...cost,
          cost: 0,
        }));

  const showReviewButton =
    !loading &&
    vStatus === 'pending' &&
    (reviewProcess === 'Manual' ||
      (reviewProcess === 'Automatic' && [null, 0, 2].includes(reviewStatus)));

  const TOTAL_COST = COST_SUMMARY?.reduce(
    (acc, cost) => acc + Number(cost?.cost),
    0,
  );

  const reviewUserPermission =
    userDetails?.permissions?.onboardPermissions?.reviewVerifications;

  const LINKS = [
    {
      path: Constants.PAGES_URL.VERIFICATIONS_BIO_DATA.replace(
        ':slug',
        verificationId || slug,
      ),
      src: biodataIc,
      text: 'Bio data',
    },
    {
      path: Constants.PAGES_URL.VERIFICATIONS_IP_DEVICE_CHECK.replace(
        ':slug',
        verificationId || slug,
      ),
      src: ipDeviceCheckIc,
      text: 'IP/Device Check',
    },
    {
      path: Constants.PAGES_URL.VERIFICATIONS_ADDRESS.replace(
        ':slug',
        verificationId || slug,
      ),
      src: addressIc,
      text: 'Address',
    },
    {
      path: Constants.PAGES_URL.VERIFICATIONS_AML_CHECK.replace(
        ':slug',
        verificationId || slug,
      ),
      src: amlCheckIc,
      text: 'AML Check',
    },
  ];

  const displayPrice = (condition, price) =>
    condition &&
    shortenLargeNumbers(price || 0, userDetails.company.currency, {});

  useEffect(() => {
    if (!isLoading && !isFetching && data?.data && data?.data?.length > 1) {
      localStorage.setItem('verificationList', JSON.stringify(data?.data));
    }
  }, [data?.data, isFetching, isLoading]);

  return (
    <DashboardLayout
      bg="bg-white xl:bg-white80"
      topPadding="pt-0"
      fullScreen
      overFlow=""
      breadCrumbs={
        <p className="text-tiny font-normal text-deepBlue">Verifications</p>
      }
    >
      <ReviewUserModal open={openReview} setOpen={setOpenReview} />
      <SessionsModal
        totalTime={VERIFICATION?.completion_time}
        open={openSessions}
        setOpen={setOpenSessions}
      />
      <ReverificationModal
        open={openRetryVerification}
        setOpen={setOpenRetryVerification}
        setOpenSuccess={setOpenRetryVerificationSuccess}
        retryType={retryType}
      />
      <ReverificationSuccessModal
        open={openRetryVerificationSuccess}
        setOpen={setOpenRetryVerificationSuccess}
        retryType={retryType}
      />

      <div className="flex items-center min-h-[52px] px-8 mx-[-32px] py-2 flex-wrap gap-3 justify-between border border-transparent border-b-[#E4E4E6]">
        <Breadcrumbs
          mainText="Verifications"
          mainTextPath={Constants.PAGES_URL.VERIFICATIONS}
          items={[
            {
              label: capitalizeEveryWord(route.split('-').join(' ')),
            },
          ]}
        />

        <PrimaryButton
          buttonText={isDownloading ? 'Downloading...' : 'Download'}
          disabled={isDownloading}
          onClick={handleDownload}
        />
      </div>

      <div className="flex-wrap items-start min-h-full xl:flex xl:flex-nowrap basis-full">
        <div className="basis-[17.14%] flex flex-col gap-2 pt-16 sm:pt-6 xl:pt-[35px] xl:sticky xl:top-[35px]">
          <h2 className="hidden text-base font-medium sm:block text-grey whitespace-nowrap">
            Verifications Details
          </h2>
          <div className="flex items-center justify-between sm:hidden">
            <h2 className="text-base font-medium sm:hidden text-grey sm:text-xl whitespace-nowrap">
              Verifications
            </h2>
            <div
              className={`uppercase pt-[5px] pb-[3px] px-2 text-xs ${
                VERIFICATION?.status?.toLowerCase() === 'failed'
                  ? 'text-white bg-danger'
                  : 'text-success20 bg-success'
              } font-medium  rounded-full w-fit flex items-start gap-[2px]`}
            >
              {VERIFICATION?.status ?? '-'}
            </div>
          </div>
          <div className="border-b border-grey60 xl:border-none">
            {currentLists && currentLists?.length > 1 && (
              <Select
                options={verificationList}
                placeholder="Select a verification"
                value={
                  selectedVerification ||
                  (verificationList?.length > 0 && verificationList[0]) ||
                  {}
                }
                components={{DropdownIndicator}}
                classNamePrefix="react-select"
                styles={customStyles}
                className="select-verifications"
                isDisabled={isLoading}
                onChange={data => {
                  setSelectedVerification(data);
                  navigate(
                    Constants.PAGES_URL.VERIFICATIONS_BIO_DATA.replace(
                      ':slug',
                      data?.value,
                    ),
                  );
                }}
              />
            )}

            <div className="flex gap-2 xl:p-2 xl:flex-col">
              {LINKS.map(({path, src, text}) => (
                <ReusableLink key={path} path={path} src={src} text={text} />
              ))}
            </div>
          </div>
        </div>

        <div className="xl:ml-[37px] xl:basis-[45.67%] mt-6 xl:mt-0 px-4 grow xl:grow-0 xl:p-8 pt-4 xl:pt-[36px] bg-white80 xl:bg-white">
          {children}
        </div>

        <div className="xl:basis-[36.04%] xl:px-6 py-10 xl:sticky xl:top-[35px] bg-white xl:bg-white80">
          <div className="flex items-center justify-between mb-1">
            {!loading ? (
              <div className="flex items-center justify-between">
                <div
                  className={`flex uppercase pt-[5px] pb-[3px] px-2 text-xs  font-medium ${
                    getStatusTextAndStyles(vStatus).styles
                  } rounded-full w-fit items-start gap-[2px]`}
                >
                  {!vStatus ? '...' : getStatusTextAndStyles(vStatus).text}
                </div>

                {/* <SecondaryButton
                  buttonText="Download"
                  className="w-fit h-11   flex items-center justify-center !py-5 !px-4"
                /> */}

                {/*{isReviewerStatus && (*/}
                {/*  <div className="flex items-center p-2 bg-brandBlue4 rounded">*/}
                {/*    <p className="font-medium text-xs">{"Reviewer's Status"}</p>*/}
                {/*    <div*/}
                {/*      className={`flex uppercase pt-[5px] pb-[3px] px-2 text-xs ml-3  font-medium ${*/}
                {/*        getStatusTextAndStyles(rStatus || 'pending').styles*/}
                {/*      } rounded-full w-fit items-start gap-[2px]`}*/}
                {/*    >*/}
                {/*      {getStatusTextAndStyles(rStatus || 'pending').text}*/}
                {/*    </div>*/}
                {/*  </div>*/}
                {/*)}*/}
              </div>
            ) : (
              <SkeletonLoader
                style={{
                  height: 20,
                  width: 100,
                  marginBottom: 0,
                  borderRadius: 50,
                }}
              />
            )}

            <div className="flex items-center gap-4">
              <SecondaryButton
                className="flex items-start"
                fontSize="text-xs"
                xPadding="px-2"
                yPadding="pt-[9px] pb-[7px]"
                btnHeight="h-7"
                buttonText="Reverify"
                onClick={() => {
                  setOpenRetryVerification(!openRetryVerification);
                  setRetryType('re-verify');
                }}
                disabled={VERIFICATION?.reverification_enabled || loading}
              />
              {showReviewButton && (
                <PrimaryButton
                  buttonText="Review user"
                  fontSize="text-xs"
                  xPadding="px-2"
                  yPadding="pt-[10px] pb-[8px]"
                  className="hidden sm:flex"
                  onClick={() => setOpenReview(!openReview)}
                  disabled={!reviewUserPermission}
                />
              )}
              <div
                className="fixed bottom-0 left-0 right-0 z-10 px-4 py-2 overflow-x-hidden sm:hidden bg-white80"
                style={{boxShadow: '0px -1px 8px rgba(51, 52, 66, 0.25)'}}
              >
                {!loading && vStatus === 'pending' && (
                  <PrimaryButton
                    buttonText="Review user"
                    xPadding="p-[35px]"
                    className="w-full bottom-2"
                    onClick={() => setOpenReview(!openReview)}
                    disabled={!reviewUserPermission}
                  />
                )}
              </div>
            </div>
          </div>
          <div className="flex flex-col gap-1 p-4 mt-2 text-xs uppercase rounded bg-white80 xl:bg-white text-body">
            <span className="font-medium">Reference ID</span>
            <span>{VERIFICATION?.reference_id ?? '-'}</span>
          </div>
          {vStatus === 'pending' && VERIFICATION?.comment && (
            <div className="flex flex-col gap-1 p-4 mt-4 text-xs rounded bg-white80 xl:bg-white text-body">
              <div className="flex items-center mb-2">
                <img src={failed_t} alt="" />
                <p className="ml-2 text-xs font-medium uppercase text-grey">
                  Reason for Pending verification
                </p>
              </div>

              <span className="text-[0.75rem] leading-[18px] text-[#4A4A68] opacity-80">
                {VERIFICATION?.comment}
              </span>
              {VERIFICATION?.service_provider_down === true && (
                <div className="flex justify-end">
                  <PrimaryButton
                    className="flex items-start gap-2 mt-2"
                    fontSize="text-xs"
                    xPadding="px-2"
                    yPadding="pt-[9px] pb-[7px]"
                    buttonText="Retry verification"
                    btnHeight="h-7"
                    src={chevronRightSm}
                    width={12}
                    height={12}
                    onClick={() => {
                      setOpenRetryVerification(!openRetryVerification);
                      setRetryType('retry');
                    }}
                    disabled={VERIFICATION?.retried_enabled || loading}
                  />
                </div>
              )}
            </div>
          )}
          <div className="flex flex-wrap items-stretch gap-4 mt-4 lg:flex-nowrap">
            <></>
            <div className="w-full p-4 rounded bg-white80 xl:bg-white">
              <p className="mt-2 text-xs font-medium uppercase text-grey">
                Total time spent
              </p>
              <p className="mt-2 text-xs text-body">
                The amount of time taken to process verification details
              </p>
              <p className="mt-2 text-xl font-medium text-grey">
                {VERIFICATION?.completion_time
                  ?.replace('m', ':')
                  .replace('s', '') || '00:00'}
              </p>
            </div>
            <div className="w-full p-4 rounded bg-white80 xl:bg-white">
              <p className="mt-2 text-xs font-medium uppercase text-grey">
                Sessions
              </p>
              <p className="mt-2 text-xs text-body">Number of sessions</p>
              <p className="mt-2 text-xl font-medium text-grey">
                {session_summary?.data?.sessions?.length || 1}
              </p>
              <SecondaryButton
                className="flex items-start gap-2 mt-2"
                fontSize="text-xs"
                xPadding="px-2"
                yPadding="pt-[9px] pb-[7px]"
                buttonText="View all sessions"
                btnHeight="h-7"
                src={chevronRightSm}
                width={12}
                height={12}
                onClick={() => setOpenSessions(!openSessions)}
              />
            </div>
          </div>

          <div className=" p-4 bg-white items-stretch  mt-4 w-full">
            <p className="mt-2 text-xs font-medium uppercase text-grey">
              date/time created
            </p>
            <div className="mt-2 flex rounded w-full">
              <p className="font-medium text-grey">
                {VERIFICATION && VERIFICATION.date_created
                  ? moment(VERIFICATION.date_created).format('Do MMMM YYYY')
                  : loading
                  ? '-'
                  : '-'}
              </p>

              <p className=" font-medium text-grey">
                ,{' '}
                {VERIFICATION && VERIFICATION.date_created
                  ? moment(VERIFICATION.date_created).format('hh:mm A')
                  : loading
                  ? '-'
                  : '-'}
              </p>
            </div>
          </div>

          {/********************   WEBHOOK STATUS    **********************/}
          <div className=" p-4  bg-white   mt-4 w-full flex items-center gap-2">
            <p className="uppercase font-medium text-grey text-xs">
              webhook status
            </p>
            {typeof webhookStatus === 'boolean' && (
              <div
                className={`flex uppercase pt-[4px] pb-[4px] px-2 text-[9px]  font-medium ${
                  getStatusTextAndStyles(webhookStatus?.toString()).styles
                } rounded-full w-fit items-start gap-[2px]`}
              >
                {getStatusTextAndStyles(webhookStatus?.toString()).text}
              </div>
            )}

            <div className="ml-auto">
              <PrimaryButton
                className="flex items-start gap-2 "
                fontSize="text-xs"
                xPadding="px-2"
                yPadding="pt-[8px] pb-[7px]"
                buttonText="Resend"
                btnHeight="h-7"
                src={chevronRightSm}
                width={12}
                height={12}
                onClick={() => refetch()}
                disabled={isResending}
                loading={isResending}
              />
            </div>
          </div>

          {loading ? null : VERIFICATION?.review_process?.toLowerCase() ===
            'manual' ? (
            <>
              {(vStatus === 'failed' ||
                VERIFICATION?.r_action?.toLowerCase() === 'failed' ||
                VERIFICATION?.r_action?.toLowerCase() === 'completed') &&
                vStatus !== 'completed' &&
                vStatus !== 'successful' &&
                VERIFICATION?.r_action && (
                  <div className="w-full p-4 rounded bg-white80 xl:bg-white mt-4">
                    <div className="flex items-center mb-2">
                      {/*<img src={failed_t} alt="" />*/}
                      <p className=" text-xs font-medium uppercase text-grey">
                        recommended action
                      </p>
                    </div>
                    <p className="mt-2 text-sm text-body">
                      {VERIFICATION?.r_action || '-'}
                    </p>
                  </div>
                )}
              {(vStatus === 'pending' || vStatus === 'failed') &&
                vStatus !== 'successful' &&
                vStatus !== 'completed' &&
                VERIFICATION?.comment && (
                  <div className="w-full p-4 rounded bg-white80 xl:bg-white mt-4">
                    <div className="flex items-center mb-2">
                      <img src={failed_t} alt="" />
                      <p className="ml-2 text-xs font-medium uppercase text-grey">
                        reason for{' '}
                        {VERIFICATION?.r_action?.toLowerCase() === 'failed'
                          ? VERIFICATION?.r_action
                          : vStatus}{' '}
                        verification
                      </p>
                    </div>
                    <p className="mt-2 text-sm text-body">
                      {VERIFICATION.comment || '-'}
                    </p>
                  </div>
                )}
            </>
          ) : (
            <>
              {loading
                ? null
                : vStatus !== 'successful' &&
                  vStatus !== 'completed' &&
                  vStatus !== 'pending' &&
                  vStatus !== 'failed' &&
                  VERIFICATION?.r_action && (
                    <div className="w-full p-4 rounded bg-white80 xl:bg-white mt-4">
                      <div className="flex items-center mb-2">
                        {/*<img src={failed_t} alt="" />*/}
                        <p className=" text-xs font-medium uppercase text-grey">
                          recommended action
                        </p>
                      </div>
                      <p className="mt-2 text-sm text-body">
                        {VERIFICATION?.r_action || '-'}
                      </p>
                    </div>
                  )}
              {vStatus === 'failed' && VERIFICATION?.comment && (
                <div className="w-full p-4 rounded bg-white80 xl:bg-white mt-4">
                  <div className="flex items-center mb-2">
                    <img src={failed_t} alt="" />
                    <p className="ml-2 text-xs font-medium uppercase text-grey">
                      reason for {vStatus} verification
                    </p>
                  </div>
                  <p className="mt-2 text-sm text-body">
                    {VERIFICATION.comment || '-'}
                  </p>
                </div>
              )}{' '}
              {Array.isArray(COST_SUMMARY) && COST_SUMMARY?.length > 0 && (
                <div className="w-full p-4 rounded bg-white80 xl:bg-white mt-4">
                  <div className="flex items-center mb-2">
                    <p className="text-xs font-medium uppercase text-grey">
                      Total cost
                    </p>
                  </div>
                  <p className="mt-2 text-xl text-grey font-medium flex items-end gap-2">
                    {displayPrice(TOTAL_COST, TOTAL_COST / 100)}
                    {/*<span className="text-base text-body mb-[2px]">NGN</span>*/}
                  </p>
                </div>
              )}
              {Array.isArray(COST_SUMMARY) && COST_SUMMARY?.length > 0 && (
                <div className="w-full p-4 rounded bg-white80 xl:bg-white mt-4">
                  <div className="flex items-center mb-2">
                    <p className="text-xs font-medium uppercase text-grey">
                      Cost Summary breakdown
                    </p>
                  </div>
                  <CostSummary
                    summary={COST_SUMMARY}
                    displayPrice={displayPrice}
                  />
                </div>
              )}
            </>
          )}

          <ActivityLog />
        </div>
      </div>
    </DashboardLayout>
  );
}

export default connect(state => state, Actions)(Layout);
